module.exports = __webpack_public_path__ + "aa7c5fa494807f7a9ec907defee083e8.woff2";